import { HomeScreenConfigSchema, type HomeScreenConfig } from '@school-journey/shared-types'

import type { ScreenFeatureEntry } from './entry'

/**
 * Screen `home`.
 *
 * Not absentIsEmpty: the fleet-default SCREEN_CONFIGS row carries `home`
 * (read-only production query, `SystemConfiguration`, 2026-10-02).
 *
 * No fallback: the schema documents absent `homeCardLayout` as "stack" and
 * absent `backgroundOverlayStrength` as "no wash", but no resolver line in
 * `apps/mobile/src` or `apps/backend/src` was found to cite, so neither is
 * filled here.
 *
 * Sparse, but the panel's two removals ("reset dimming to default", "switch the
 * welcome-card button off") cannot ride a merge, so those saves go out as the
 * full replace write (`use-screen-feature.ts`, the save path).
 */
export const home: ScreenFeatureEntry<'screen', 'home', HomeScreenConfig> = {
  resource: 'screen',
  wireName: 'home',
  schema: HomeScreenConfigSchema,
  // Sparse (U9a): merged inside the server's compare-and-swap, so concurrent sibling saves both land.
  writeMode: 'sparse',
  fallback: {}
}
